
import styles from './DisbursementHeader.module.scss';
import MeritoLongLogo from '../../../assets/images/MeritoDarkLogo.webp';
import MeritoShortLogo from '../../../assets/images/short-violet-logo.webp';
import { RiCloseFill as XSeparatorIcon } from 'react-icons/ri';
import { getLocalUser } from '../../../components/functions/utilities';
import { Form } from 'react-final-form';
import { useMediaQuery } from 'react-responsive'
import { useResponsive } from '../../../components/Hooks/useResponsive';

type Props = {
    actionBtn?: React.ReactNode | null
}

const DisbursementHeader = ({ actionBtn = null }: Props) => {
    const currentUser = getLocalUser();
    const { isMobile } = useResponsive();
    // console.log('isMobile', isMobile)
    return (
        <div className={styles.headerRootContainer}>
            <div className={styles.leftContainer}>
                {isMobile ?
                    <div className={styles.meritoIcon}>
                        <img src={MeritoShortLogo} />
                    </div>
                    :
                    <>
                        <div className={styles.meritoIcon}>
                            <img src={MeritoLongLogo} />
                        </div>
                        <div className={styles.iconContainer}>
                            <XSeparatorIcon />
                        </div>
                        <div className={styles.brandName}>
                            {currentUser?.companyName}
                        </div>
                    </>}
            </div>
            <div className={styles.rightContainer}>
                {actionBtn ?
                    <div className={styles.actionBtnContainer}>
                        {actionBtn}
                    </div>
                    : null}
            </div>

        </div>
    );
}

export default DisbursementHeader;